import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { ParcelaPagamento } from "../api/dto/parcela-pagamento";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ParcelaPagamentoService {
    constructor(private http: HttpClient) {}

    private url: string = UrlServidor.URL_BASE + 'parcelas_pagamento/';

    buscarPorId(id?: number): Observable<ParcelaPagamento> {
        return this.http.get<ParcelaPagamento>(this.url + id);
    }

    listarTodos(): Observable<ParcelaPagamento[]> {
        return this.http.get<ParcelaPagamento[]>(this.url);
    }

    listarPorEmpresa(empresaId?: number): Observable<ParcelaPagamento[]> {
        return this.http.get<ParcelaPagamento[]>(this.url + 'empresa/' + empresaId);
    }

    listarPorTipoPagamento(id?: number): Observable<ParcelaPagamento[]> {
        return this.http.get<ParcelaPagamento[]>(this.url + 'tipo-pagamento/' + id);
    }

    obterQuantidadeParcelas(idTipoPagamento?: number): Observable<number[]> {
        return this.http.get<number[]>(this.url + 'tipo-pagamento/' + idTipoPagamento + '/quantidade-parcelas')
    }

    salvar(parcelaPagamento?: ParcelaPagamento): Observable<ParcelaPagamento> {
        return this.http.post<ParcelaPagamento>(this.url, parcelaPagamento);
    }

    atualizar(parcelaPagamento?: ParcelaPagamento, id?: number): Observable<ParcelaPagamento>{
        return this.http.put<ParcelaPagamento>(this.url + id, parcelaPagamento);
    }

    excluir(id?: number): Observable<void>{
        return this.http.delete<void>(this.url + id);
    }
}